import { Input } from "@sablier/v2-components/organisms";
import { useT } from "@sablier/v2-locales";
import { _ } from "@sablier/v2-mixins";
import type { IStreamOption } from "~/client/contexts/Form/Search";
import {
  useFieldChain,
  useFieldRecipient,
  useFieldSender,
  useFieldStreams,
} from "../logic";

function Recipient() {
  const { recipient, isLoading, onBlur, onChange, onFocus, label } =
    useFieldRecipient();
  const { t } = useT();

  return (
    <Input.Address
      id={recipient.field.id}
      isLoading={isLoading}
      info={isLoading && t("form.placeholder.resolving")}
      label={label}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
      placeholder={t("form.placeholder.address")}
      resolution={recipient.field.resolution?.short}
      value={recipient.field.value}
      warning={!isLoading && recipient.field.warning}
    />
  );
}

function Sender() {
  const { isLoading, label, onBlur, onChange, onFocus, sender } =
    useFieldSender();
  const { t } = useT();

  return (
    <Input.Address
      id={sender.field.id}
      isLoading={isLoading}
      info={isLoading && t("form.placeholder.resolving")}
      label={label}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
      placeholder={t("form.placeholder.address")}
      resolution={sender.field.resolution?.short}
      value={sender.field.value}
      warning={!isLoading && sender.field.warning}
    />
  );
}

function Chain() {
  const { chain, onChange, source, value } = useFieldChain();
  const { t } = useT();

  return (
    <Input.TextStepper
      id={chain.field.id}
      label={{ value: t("words.chain") }}
      isChevron
      isOnlyRight={false}
      onChange={onChange}
      source={source}
      value={value}
      warning={chain.field.warning}
    />
  );
}

function Streams() {
  const { streams, onAdd, onBlur, onChange, onRemove } = useFieldStreams();
  const { t } = useT();

  return (
    <Input.TextList<IStreamOption>
      id={streams.field.id}
      current={streams.field.current}
      label={{ value: _.capitalize(t("words.streams")) }}
      onAdd={onAdd}
      onBlur={onBlur}
      onChange={onChange}
      onRemove={onRemove}
      placeholder={t("form.placeholder.streamOptions")}
      value={streams.field.value}
      warning={streams.field.warning}
    />
  );
}

const Fields = {
  Recipient,
  Sender,
  Chain,
  Streams,
};

export default Fields;
